module.exports = __webpack_public_path__ + "img/benefit-04-camera-4.e3c4b64c.png";